export function headerMenu () {
  const headerMenu = document.querySelector('.js-headerMenu');
  const headerMenu_items = document.querySelectorAll('.js-headerMenu_item');
  const headerMenu_subs = document.querySelectorAll('.js-headerMenu_sub');
  const headerMenu_btns = document.querySelectorAll('.js-headerMenu_btn');

  headerMenu_items.forEach(item => {
    const menu = item.querySelector('.js-headerMenu_sub');
    const btn = item.querySelector('.js-headerMenu_btn');
    item.addEventListener('mouseover', () => {
      resetActive();
  
      if (!menu || !btn) return;
      
      menu.classList.add('is-active');
      btn.classList.add('is-active');

      menu.addEventListener('mouseleave', () => {
        menu.classList.remove('is-active');
        btn.classList.remove('is-active');
      })
    })
  });

  document.addEventListener('pointerdown', (e) => {
    // メニュー内をタップしていれば何もしない
    if (headerMenu.contains(e.target)) return;

    resetActive();
  });

  function resetActive() {
    headerMenu_subs.forEach(sub => sub.classList.remove('is-active'));
    headerMenu_btns.forEach(btn => btn.classList.remove('is-active'));
  }
}